import { render, staticRenderFns } from "./AltaCuentasClinica.vue?vue&type=template&id=5f4782aa"
import script from "./AltaCuentasClinica.vue?vue&type=script&lang=js"
export * from "./AltaCuentasClinica.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports